<script lang="ts"></script>

<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 486 324">
  <g>
    <g class="image">
      <rect width="354" height="300" x="66" y="12" fill="url(#pattern0_22539_38951)" rx="12" />
    </g>
    <g class="icone">
      <g filter="url(#filter0_d_22539_38951)">
        <rect width="72" height="72" x="378" y="30" fill="#fff" rx="36" />
        <g>
          <path
            fill="#000091"
            d="M422.33 52.67a10 10 0 0 1 10 10v6.66a10 10 0 0 1-10 10h-16.66a10 10 0 0 1-10-10v-6.66a10 10 0 0 1 10-10zM410.67 61h-3.34v3.33H404v3.34h3.33V71h3.34v-3.33H414v-3.34h-3.33zM424 67.67h-3.33V71H424zM420.67 61h-3.34v3.33h3.34z"
          />
        </g>
      </g>
    </g>
    <g class="icone">
      <g filter="url(#filter1_d_22539_38951)">
        <rect width="56" height="56" x="46" y="207" fill="#fff" rx="28" />
        <g>
          <path
            fill="#000091"
            fill-rule="evenodd"
            d="M86 223v2.67a9.33 9.33 0 0 1-9.33 9.33h-1.34v1.33H82v9.34c0 1.47-1.2 2.66-2.67 2.66H68.67a2.67 2.67 0 0 1-2.67-2.66v-9.34h6.67v-4A9.33 9.33 0 0 1 82 223zm-20.67-1.33a10 10 0 0 1 8.17 4.22 10.6 10.6 0 0 0-2.17 6.44v1.34h-.66a10 10 0 0 1-10-10v-2z"
            clip-rule="evenodd"
          />
        </g>
      </g>
    </g>
    <path
      stroke="#000091"
      stroke-linecap="round"
      stroke-miterlimit="10"
      stroke-width="3"
      d="M35.22 155.9c-3.17-.67-5.63-4.62-3.3-7.95 2.01-2.87 6.99-2.5 8.6.63 1.05 2.06.3 4.86-1.4 6.3a4.5 4.5 0 0 1-3.9 1.02Z"
      class="trace"
      pathLength="1"
    />
    <path
      stroke="#000091"
      stroke-linecap="round"
      stroke-miterlimit="10"
      stroke-width="3"
      d="M160.14 184.58c-12.54 15.14-35.05 20.86-53.43 13.8-18.38-7.08-31.22-26.66-30.57-46.44.3-7.1 2.21-14.33 6.56-19.85s11.5-9.18 18.5-8.28c12.54 1.54 19.8 17.72 14.63 29.2-5.19 11.49-19.34 17.14-31.73 14.77-12.4-2.36-22.88-11.1-30.08-21.42-18.13-25.91-18.18-59.9-17.57-91.43"
      class="trace"
      pathLength="1"
    />
  </g>
  <defs>
    <filter
      id="filter0_d_22539_38951"
      width="108"
      height="108"
      x="360"
      y="18"
      color-interpolation-filters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
      <feOffset dy="6" />
      <feGaussianBlur stdDeviation="9" />
      <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0705882 0 0 0 0.16 0" />
      <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_22539_38951" />
      <feBlend in="SourceGraphic" in2="effect1_dropShadow_22539_38951" result="shape" />
    </filter>
    <filter
      id="filter1_d_22539_38951"
      width="92"
      height="92"
      x="28"
      y="195"
      color-interpolation-filters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
      <feOffset dy="6" />
      <feGaussianBlur stdDeviation="9" />
      <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0705882 0 0 0 0.16 0" />
      <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_22539_38951" />
      <feBlend in="SourceGraphic" in2="effect1_dropShadow_22539_38951" result="shape" />
    </filter>
    <pattern id="pattern0_22539_38951" width="1" height="1" patternContentUnits="objectBoundingBox">
      <use href="#image0_22539_38951" transform="matrix(.00083658 0 0 .00098717 -.252924 0)" />
    </pattern>
    <image
      id="image0_22539_38951"
      width="1800"
      height="1013"
      href="/assets/images/mini-tests/animation/scene-hero-mini-test.avif"
      preserveAspectRatio="none"
    />
  </defs>
</svg>
